import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updateItemRecipe } from '@/redux/utils/update-item-recipe';
import { Organisation } from '@/types/organisation';
import { UpdateOrganisationQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchUpdateOrganisation: DispatchOptimisticPatchHandler<
  UpdateOrganisationQueryArg
> = (queryArg, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getOrganisations',
      undefined,
      updateItemRecipe<Organisation, 'id'>('id', queryArg.id, queryArg),
    ),
  );

  return { patch };
};
